export * from "./MCQTest/mcq-dashboard/mcq-dashboard.component";
export * from "./MCQTest/registeration/registeration.component";
export * from "./MCQTest/instruction/instruction.component";
export * from "./MCQTest/more-info/more-info.component";
export * from "./MCQTest/result/result.component";
export * from "./MCQTest/confirm/confirm.component";
export * from "./MCQTest/invitation-form/invitation-form.component";
export * from "./MCQTest/register/register.component";
export * from "./MCQTest/thanks/thanks.component";
export * from "./MCQTest/navigator/navigator.component";
